
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Clair`,
'deleteKey': `⌦ Supprimer`,
'downKey': `↓ Bas`,
'endKey': `⤓ Fin`,
'enterKey': `Entrer`,
'escapeKey': `⎋ Escape`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Générer une 
          <code>LICENSE
          </code> fichier
        `,
'homeKey': `⤒ Accueil`,
'keyCommand': `⌘ Command/Win`,
'keyControl': `Contrôle`,
'keyOption': `⌥ Option/Alt`,
'keyShift': `⇧ Majuscule`,
'leftKey': `← Gauche`,
'pagedownKey': `▼ Pagedown`,
'pageupKey': `▲ Pageup`,
'rightKey': `→ Droit`,
's00065e45db8c0441': `Voir les outils de développement pour plus de détails`,
's001dd78415a91fa0': `Gouttière de la barre de défilement`,
's002fa7d1054ed082': `Boîte à bordures`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Kazakh`,
's01b56d233c6c5cac': `Sectionnement`,
's01d32b35baa3b676': `Auteur`,
's02106cc2ef0e7578': `Nouvelle épingle...`,
's02ab1ea8e5100fc1': `Marquer la sélection comme une "dérogation bidirectionnelle".`,
's0312976fe9da5951': `Bouton`,
's03608a32f05eded2': `Zoom par pincement`,
's036d35e03be98d22': `Profondeur des mathématiques`,
's037b1dc850a89273': `Autre sous`,
's0396202b716732ec': `Marquer la sélection comme rayée`,
's03f49e598ffb11cc': `Polonais`,
's0448f1059fa01720': `Enregistrez, partagez ou imprimez votre explorable. Modifiez les informations telles que le titre, la langue ou la licence.`,
's0458872c43beadef': `Insérer une ligne avant`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Espacement des mots`,
's05e9759cfd99c48f': `Justifier`,
's063fa5a0a4903bf4': `Latéralement, de gauche à droite`,
's064339c229374050': `Encodage`,
's06634274f19b0572': `Sélection des broches`,
's06743b24499f0035': `Centre d'ancrage`,
's07808b0ca6da8fef': `Site clôturé`,
's07970793b21351fd': `Conteneur de base Ruby`,
's079cf7850d9327f0': `Police`,
's07aa10850d9ddcc7': `Formulaire`,
's07e6118e838b2e23': `Navigation`,
's0816468df86e4036': `Ouvre les paramètres`,
's082869038c117fe5': `Portugais (Brésil)`,
's086e6c267ade2609': `Saturation`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Audio`,
's0978fb5ba3145996': `Insérer une liste (non ordonnée)`,
's09c3f1d21de14ae1': `Marquer la sélection comme étant soulignée`,
's0a2d91c6720033e9': `Espacement du texte`,
's0a3ddcba94027d95': `Ajustement de l'objet`,
's0a6cb8d42cdb0c4a': `Espéranto`,
's0a799f583098cadf': `Insérer une navigation`,
's0a7db790db1fc45c': `Marquer la sélection comme une portée`,
's0b1271f50a77dc73': `Boîte à contenu`,
's0b24d08ea349b455': `Tout ce que vous pouvez insérer. Au début, on trouve des éléments non interactifs comme des listes ou des images, puis des éléments interactifs appelés "widgets". Vous pouvez en obtenir de nouveaux en cliquant sur la barre de recherche.`,
's0bdca49248ba4820': `Raccourcis`,
's0befccf152b6c0a9': `Orienter à partir des métadonnées`,
's0c11e479416c8421': `Insérer une légende de tableau`,
's0c27336067c59611': `Rembourrage du défilement`,
's0c4593d81f147042': `Base de référence`,
's0c4b2e98d4ab7f5a': `Commandes d'applications`,
's0c883713b83616a8': `Sauvegarder le document actif`,
's0ca5c0460199cba1': `Abréviation`,
's0cf10c4f40588f8d': `Légende du tableau`,
's0d86afa3c6a1e28b': `Direction de la flexion`,
's0dad143dff0079fc': `Malayalam`,
's0db05bd7ba6fff96': `Votre document explorable. Vous pouvez y écrire du texte et le copier/coller, le modifier, etc.`,
's0dc452999c129e15': `Activer la recharge en direct`,
's0de0febab8a4beaf': `Erreur de lecture de ce paquet`,
's0e44968489e076a8': `Chinois`,
's0e4862e87c7d53ce': `Marquer la sélection comme une citation`,
's0e6ea8870dbddab2': `Commandes de documents`,
's0ee28503778e4c0c': `Dernière ligne de base`,
's0ef01c03299bbb83': `Décoration`,
's0f17f32919661cff': `Mongol`,
's0f350bc4e538e3ea': `Mots`,
's105a06836c40fcb4': `Définir des filtres, des couleurs et des mélanges pour les éléments sélectionnés`,
's106b274b5af798e5': `Phrases`,
's1082e1649793dca9': `Marquer la sélection comme un terme défini`,
's10f3845975a0351e': `Modifier les métadonnées`,
's1125d159f7e64df5': `Affichage`,
's11326fd2590f4e5e': `Défaut`,
's1155ec07a221e739': `Barre de défilement`,
's1173bf7a3e0b74c9': `Minimum (y)`,
's1177237a3e0e548c': `Minimum (x)`,
's1219d97b49650c05': `Visibilité`,
's123bea44f38abccf': `Insérer un objet`,
's1245e2cb9f20197e': `Aligner`,
's12946ec1b850962c': `Insérer une colonne après`,
's1351209ef74ee729': `Étendre toutes les colonnes`,
's13c60cb409e8cb6f': `Aligner le centre`,
's13ebd619c8a06a6d': `Grille de lignes automatiques`,
's13ef8ca26ca8861b': `Élément de coupe`,
's151bc2eea7a032a4': `-changé-`,
's153bc3c3aa39587b': `Tête de table`,
's156647179b21d351': `Insérer un corps de tableau`,
's158b6ec6b1fffcb2': `Pause après`,
's15d0c0657c1ee08c': `Clé API`,
's1626a7e10a9f9dcc': `Définit la famille de polices de la sélection`,
's1637c7d1a30629e2': `Boîte à bordures`,
's1641ab440bf4daa4': `Mettre à jour ce paquet de widgets`,
's166bd56d19670a72': `Zoom`,
's1696c76a23c0834e': `Avancé : Afficher les paquets avec des versions comme 0.x.x dans le gestionnaire de paquets`,
's16b9446e3a70e1f4': `Attributs`,
's16f205466761e583': `Pas de dimensionnement optique des polices`,
's16f2f1c2c516d307': `Ouvrir un document`,
's1749014f3f87fa6a': `Étirer`,
's17597a8bb4810524': `Licence`,
's17bfaaa4e7528bc7': `Bashkir`,
's17fb3f4805f4f4b9': `Supprimer le champ`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Créer un paquet`,
's18d5c44aae3dc82a': `En ligne lors de l'édition`,
's1988d71ef8060edf': `Insérer une ligne de tableau`,
's19abee1277c9bca2': `Samoan`,
's19daf2f26c19543d': `Aperçu`,
's1a1acc902e6668e0': `Afficher le formatage avancé du texte`,
's1a5230a71d9285c1': `Capture`,
's1aa1cb63ad44bc6f': `Espace entre les colonnes`,
's1af8b67d1c85c811': `Espace entre`,
's1b4a36fce2456660': `Famille de polices`,
's1c246045629b0016': `Marquer la sélection comme une suppression`,
's1c3fc313a9184670': `Lien public`,
's1c65f5004a07dcfa': `Gaelic écossais`,
's1c690963f1e2df00': `Aspect spécifique à la plate-forme`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Vous souhaitez une visite guidée de courte durée ?`,
's1d19244f549ec535': `L'éducation`,
's1d5c7b28e8b50d6d': `Diplôme d'associé.`,
's1db591f5a54dbfd3': `Boîte de contenu`,
's1dbb9f50e16c92a3': `Rayon de la bordure`,
's1dfb744260fb3a01': `Isolation bidirectionnelle`,
's1e9c2c654732cc5f': `Biélorusse`,
's1eaccbf2d6af8ab5': `Informations`,
's1efbfc3937d565bd': `Contexte`,
's1f2b49c1bca2035d': `Catalan`,
's1f74bdf32b51a5fc': `Image de fond`,
's1f7698c061c208c9': `Ouvrir`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Corse`,
's21d61916eb8d137d': `Corps de table`,
's21d723a1dbcd89c8': `Javanais`,
's21f8a2eaf5a70749': `Insérer une étiquette`,
's2206c42e5b835e6e': `Marquer la sélection comme une abréviation`,
's22a2348c46a912a0': `Insérer une section`,
's233ae776268cd44b': `Entreprises`,
's236ed7ba747099b0': `Poids de la police`,
's2474e7fb1aec9f05': `Test`,
's2492f5fb1b05b45e': `Texte`,
's24949d7adbb5a098': `Boîte à outils`,
's252a52330d32b900': `Métadonnées`,
's2540844a4bc4d9ba': `Exiger l'attribution ?`,
's255857544a9d5ec0': `Remise à zéro`,
's255c77900f2b5e0f': `Schéma de couleurs`,
's256ab831a48c941c': `Supprime la mise en forme du texte de la sélection`,
's2591806d7b222591': `Réinitialiser les changements`,
's25e1a07e454c2c11': `Grille`,
's262abbaf1d05f009': `Lumière douce`,
's266935f2447fcd98': `Plus à gauche`,
's268ecd1cef45a9a8': `Êtes-vous sûr ?`,
's2692bc028fed91f1': `⇪ Verrouillage des majuscules`,
's27056379e0acfdb0': `Alléger`,
's27076e66c5d483ba': `Alignement vertical`,
's2712dc5641a33226': `Les comptes de registre de paquets sont destinés aux développeurs et vous permettent de configurer un ou plusieurs registres`,
's27cc88818cc46ff6': `Stable`,
's281d957112b10f12': `Modifier directement le code HTML du document`,
's28b6246ce616a548': `Insérer un groupe de colonnes de tableau`,
's29a1c26521879b9f': `Réduire l'échelle`,
's29acfd2778e8c377': `Masquer le formatage avancé du texte`,
's29b24c06315e9343': `Insérer une entrée`,
's29eb103449472e3b': `Insérer un titre (niveau 3)`,
's29ee7434494a0dfe': `Insérer un titre (niveau 2)`,
's29f21c34494d614d': `Insérer un titre (niveau 1)`,
's29fbfc3449557f72': `Insérer un titre (niveau 6)`,
's29ff743449588131': `Insérer un titre (niveau 5)`,
's2a031834495bcdb4': `Insérer un titre (niveau 4)`,
's2a75c946ef4dcab7': `Divers`,
's2b2ae20d26f78ac2': `Bloc`,
's2b8f50c64be440f7': str`Sélectionner 
          ${0}...
        `,
's2ba5f4d8f3bd7c57': `Commande`,
's2bad2d24def4aa0b': `Saut de ligne (CJK lang.)`,
's2ceb11be2290bb1b': `Annuler`,
's2ced8e8fafb499f6': `Supprimer un élément`,
's2d986d31f8d67357': `Insérer un ensemble de champs`,
's2d995a37cf5e4995': `Insérer un NoScript`,
's2de969afacdaa7a6': `Forme`,
's2df075aface0dab8': `Partager`,
's2e192b19ed15fcf6': `Page`,
's2e39b99cf23606fa': `Définir la disposition des éléments sélectionnés`,
's2e4818861000b13f': `Mise en page`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Marathi`,
's2eda5288a65bca1d': `Débordement (y)`,
's2edd6688a65e21f0': `Débordement (x)`,
's2f0bcdffc92a786b': `Flotteur droit`,
's2f2044f2431a32d5': `Rubrique`,
's2f4d4bfbc466d91f': `Albanais`,
's2f8da2cb5f236588': `Le nom de votre paquetage. Doit être scopé, par exemple \`@org/pkg\`. `,
's30cce87854901922': `Préscolaire`,
's3124653c272f054c': `Couleur de la règle de la colonne`,
's314a4f7685c8e824': `Toujours`,
's31c06e226322f065': `Éviter les orphelins`,
's323dcde72b850272': `Accès public`,
's32911e52ee8ac745': `Insérer une fente`,
's337a1e9022a8d19f': `Tableau`,
's33c1450d2822bb0f': `Insérer une légende de figure`,
's33c18d5a4cbffa2a': `Irlandais`,
's33f85f24c0f5f008': `Économiser`,
's342b0cabfa672822': `Aidez l'utilisateur à trouver votre widget`,
's3437e0d9899e7ae1': `Envoyer des données télémétriques sur votre utilisation de WebWriter.`,
's344ea8f4939cdc98': `Couleur`,
's34dcda3b0f9d5a98': `Toggle url`,
's34f724979a124c50': `Définit la couleur d'arrière-plan du texte sélectionné`,
's355b21b89ce5d9c5': `Détails`,
's35ae5f4e0fa2777b': `Alignement personnalisé`,
's35aeaff1425bca9e': `WebWriter ne prend pas en charge les supports de type `,
's35c3125c7750681e': `Citation en bloc`,
's3643189d1abbb7f4': `Code`,
's3649bacefe731bf6': `Basculer la boîte à outils`,
's365280e16a8ea32d': `Copier la sélection`,
's366991b9c9287765': `Droit`,
's36a194e38d653a26': `Annotation des données`,
's36b3cefdcb897f15': `Perspective`,
's372fae706048ce41': `Pair-impair`,
's377e24af9628c37e': `Liste ordonnée`,
's37a8c35f6581da5f': `Pas d'ancrage`,
's37fa3b9cd51c2dfd': `Définit la taille de la police de la sélection`,
's380d17664bb69531': `Insérer une colonne avant`,
's3815184eb09f0dcf': `Curseur`,
's382a2aa3984474dd': `Créer`,
's38980f98cb07ceb8': `Enregistrer le document actif en tant que copie`,
's3914cb410fca44d4': `Importation`,
's3a179f6db2972384': `Position du rubis`,
's3a5ca02f282d247e': `Partager...`,
's3ae67088bbefba98': `Emballages`,
's3b0ab4b52326316f': `Lumière`,
's3bdad99768e11911': `Explorable`,
's3cb47df8290fa94c': `Insérer une option`,
's3cf89cb47fdde7e9': `Lien`,
's3d09398e555ee5f9': `Options avancées`,
's3d249bb480032121': `Liste`,
's3d3efd1e19bdcfb4': `Annotation de la date et de l'heure`,
's3d6a732c792ccb9e': `Annotation Ruby`,
's3d93f9ea0c5a13fa': `Image`,
's3d9548e211b958ce': `Sauter les chevauchements`,
's3e092e9d1ee2c5bb': `Clip`,
's3e78ddc9a48a608d': `Jolie`,
's3eb6d1e6e79ed7c4': `Aucun document trouvé`,
's3eca5a034978754b': `Supprimer la sélection`,
's3f06e9abb6ebcb79': `Personnages`,
's3f1e7a3f2b283d3b': `Marge`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gujarati`,
's3f7e097a9b2e6181': `Insérer un article`,
's3fd83566dd643d10': `Insérer une légende`,
's3fe72792941c18f9': `Texte en bas`,
's3ffcdc5db5e7d0c5': `Inverser`,
's40e3826b7f74a3b5': `Pan (à droite)`,
's40f07d7859284a44': `Ligne de base dominante`,
's4101ada154a1b958': `Moyen`,
's410c465a5993f82d': `Opportunité de rupture de ligne`,
's41322d19c928c603': `TIC`,
's417b90913e05bc17': `Avant-première`,
's418f2020fe996832': `Confirmer les modifications`,
's41c724f0698148e9': `Marquer la sélection comme raccourci clavier`,
's41f65a763f8e44ab': `Groupe d'en-têtes de tableaux`,
's42721130228841b0': `Boîte de frappe`,
's429bd646f1cf8bc6': `Les comptes Grammar LLM vous permettent d'utiliser l'API Grammar LLM pour corriger la grammaire d'un texte.`,
's429dd933ba95549b': `Insérer une adresse`,
's42e470ef1d707a28': `Jeu automatique`,
's42ffdab1291fb3de': `Insérer une ligne après`,
's430831017f3f0499': `Obliquité (y)`,
's430bd5017f42511c': `Obliquité (x)`,
's433ba70286202ceb': `Cassez tout`,
's441b20a8a50e36b4': `Macédonien`,
's445b8acb9206db6e': `Rejeter et annuler`,
's446a924922651ea0': `Mise en valeur du texte`,
's44cdba92713de38e': `Zone quadrillée`,
's45518abd911471d0': `Croate`,
's456a8d744313852a': `Espace autour`,
's4634541f5056a546': `Abkhaze`,
's46d4abe6255cb9e1': `Réassigner le raccourci`,
's4730c232e7209c40': `Découper les deux`,
's474f0eec369d02a4': `Exemple de sortie`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Marquer la sélection comme une annotation de date/heure`,
's47ebf3a8fb3b10c1': `Orientation`,
's4802bb8eb52fbdeb': `Portail`,
's4802e47fe2e95134': `Option`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Ombre du texte`,
's4993444bfd3f3e5e': `Effondrement`,
's49ad24935b14e3df': `Quechua`,
's49c560aecfeb8c29': `Masque`,
's49dd67aed00029ef': `Mathématiques`,
's49e763aed00877a8': `Principal`,
's4a894f57eba1cf1e': `Raccourci clavier`,
's4ac1ad6ecd6bd810': `Misc. ed.`,
's4ad6e9d3c2365c98': `Lumière dure`,
's4b2c143acf931122': `Hauteur de la ligne`,
's4b58c01e2578f5e4': `Légende`,
's4bbff4e008690da1': `Éviter la page`,
's4c402ff5355fd310': `Dérogation bidirectionnelle`,
's4caed5b7a7e5d89b': `Anglais`,
's4cb38675a21b2c98': `Type de propriété non pris en charge "\${desc.type}" (traitement en tant que JSON)`,
's4cc8391f172c0cdf': `Renvoyer la visite`,
's4d528b416ac8dee2': `Insérer un groupe de titres`,
's4d546f6c87128d5b': `L'espace d'abord`,
's4dcb9315f6527f9c': `Exécution en cas de recharge`,
's4e191bdb4700a6e9': `Surplis (x)`,
's4e1c7fdb470386ac': `Overscroll (y)`,
's4e2562fe3990e621': `Erreur de connexion`,
's4e361bf8eef3759a': `Coupure de mots`,
's4ea0f21fc2a338a1': `Monter en grade`,
's4eace13b3ed74187': `Commentaire latéral`,
's4efee5b48a4593cb': `Boucle`,
's4f26e7cb7c0a8318': `Dessin vectoriel`,
's4fd2e638aabb0bb3': `WebWriter permet d'intégrer de nombreuses sources différentes. Il suffit de coller un lien vers un contenu provenant de :`,
's4fda04cbc245e18b': `Alpha`,
's4ffac3fb33a2ee9b': `Thaïlande`,
's5015a8fb33b98872': `Mince`,
's50489ffb1bde152e': `Insertion`,
's5068560b8d39663d': `Carte cliquable`,
's517acbf1f96324f9': `Poids`,
's523eb9043213ff0d': `Italique`,
's52777d434baeed9b': `Insérer un indicateur de progression`,
's52af5d7ac34c2163': `Ligne de table`,
's52e0bdc3ee304436': `Insérer un compteur`,
's531056f039febd39': `Insérer une sélection`,
's536695196d0b6dc3': `Faeroese`,
's542fcefa0bbaed86': `Ouvrir ou fermer la boîte à outils (uniquement sur les écrans étroits, sinon la boîte à outils est toujours visible sur le côté).`,
's5432ad3c84273229': `Chiffre`,
's543906d1db8b2283': `Editer `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Cambodgien`,
's54897f2764b0e4d0': `Installer ce paquet de widgets`,
's54cbfaf2a8da7818': `Pashto`,
's550839f3e4e205bb': `Marquer la sélection comme fortement importante`,
's55905c735052d295': `Pause thématique`,
's5590dbf7e425789d': `Étiquette`,
's5623aa2f83b05c76': `tibétain`,
's564d1648b1ceee9f': `A jour`,
's565cd5ffb0158c46': `Éviter la région`,
's571a4f19e2f140c7': `Pan (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Retourner`,
's5787c6d5b3b5541a': `Chemin d'accès au clip`,
's579c69f419b6caef': `Lisse`,
's587ac858dd80f6fa': `Indice`,
's58bec0ecd4f3ccd4': `Strict`,
's59404f5593c32fdc': `Crénage de la police`,
's5941292bb77281ab': `Norvégien Bokmål`,
's599dcd2472c75c19': `Paragraphe`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Marquer la sélection avec une annotation de données`,
's5a356677b61a6b7e': `Moldavie`,
's5b474b5c0ac0c7c4': `Groupe de colonnes du tableau`,
's5b517ac216f9ee62': `Latéraux`,
's5b8cc9bb61ddce15': `Insérer un paragraphe`,
's5bba2ac2e53bd1fd': `Kirghiz`,
's5be80ad6b8301710': `Démarrage en ligne`,
's5c1ecf88259b79f9': `Présentation`,
's5c2a1a52c0389c30': `Ingénierie`,
's5c63af7695445fcf': `Style de texte`,
's5d18ca4c3111be6f': `Insérer un en-tête de tableau`,
's5d87c1e588f48d90': `Pratique`,
's5d929ff1619ac0c9': `Recherche`,
's5da52af9b083c29a': `Modèle`,
's5dc77784260a7236': `automobile`,
's5e27738a2e8eb763': `S'inscrire`,
's5e2cba97c0d971bd': `Paquets de recharge`,
's5e53415a6d5719ad': `Sciences sociales`,
's5e6a7a0c30d2a270': `Sauter les chevauchements (auto)`,
's5e9e8e4d21bafedc': `Production alimentaire`,
's5ed03bb1f3a15949': `Photo`,
's5f43af3669b1e098': `Source`,
's5feaf7fd7ee567c8': `Rupture de mot`,
's600fd23c9ce971e8': `Imprimer le document actif`,
's602bbd28dae2c60f': `Auto-démarrage`,
's60ff598dfcf2c773': `Sous le droit`,
's61053f0e3ebbd272': `normal`,
's613c6ff83883c04f': `Colonne de table`,
's6196153c4b0c1ea0': `Installer`,
's61c017f6d5c303af': `Frison`,
's61ded17ca3f48c82': `Décalage du soulignement`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Sélection de la copie`,
's624e31cd4f1b89d4': `Défilement fluide`,
's626daf42b1ab7df7': `Aligner à gauche`,
's6280bf993915c57a': `Marge de défilement`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Description`,
's63dfc5b1c1c27849': `Yiddish`,
's63e03c70f67ebf9c': `Contexte`,
's63e71d20d1eaca93': `Allemand`,
's640bc7710d0143ce': `Rétablir la dernière modification non effectuée dans le document actif`,
's64dc1fc7e3db45c9': `Créer un nouveau document`,
's65ac276544ba33cd': `Fichier SVG`,
's66765c420ee578e4': `L'espace de façon homogène`,
's669b18c6d2d9c95b': `Aucun`,
's6747dbf4ad6063ba': `Fin propre`,
's6787497df07fa97e': `Possibilité de faire défiler les arrêts`,
's67c2b60a506a09e4': `Deuxième édition.`,
's680bd4d926cd5a84': `Préserver la 3D`,
's6827930ef1aeaf99': `URL de base`,
's684a16f3c711394d': `Plus à droite`,
's687e27f036a71b32': `Isoler`,
's68b87d7b61052dc3': `Rang de table`,
's68e0e3a2bab7ce3e': `Éviter`,
's690da6b432987c6f': `Sauvegarde automatiquement les modifications apportées au document en cours. Les modifications sont restaurées lorsque WebWriter est rechargé.`,
's69311c4e25074fb3': `Lycée`,
's697400b541fbc3cd': `Sous`,
's6988ab5d47593a26': `Vous disposez de la dernière version de WebWriter.`,
's69a49786a8009f43': `Trouver des paquets...`,
's69b12144dbb6544d': `Laothian`,
's69d88ef4b2618980': `Couverture`,
's69fbbdb8ad2a084a': `Obscurcir`,
's6a31eff1ec4f71ad': `Cacher le visage (3D)`,
's6ac62e1c8c66f3bb': `Compact superscr.`,
's6b585ba37cdb8260': `Hériter`,
's6b61f8abf89586be': `Hébreu`,
's6bd7a02fdf93e653': `Aligner le contenu`,
's6cfc66b824ea05ba': `Bords nets`,
's6d02dc19e21eb49c': `Haut de page`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Vietnamien`,
's6d8b3b8047ed378d': `Mode de mélange`,
's6d8c02aee480af7a': `Menu`,
's6dadeaaee49d6d18': `Méta`,
's6dfb502188a8c7c2': `Insérer un style`,
's6e288a119281f4c2': `Rendu du texte`,
's6e4c20c6debcd5ca': `Justificatif personnalisé`,
's6f84199e62584905': `Texte préformaté`,
's6fb3053e7244d326': `Autres domaines`,
's70178e04a3b691b6': `Ouvrir les paramètres`,
's7031ca562378bde6': `Précision géométrique`,
's7060970b5ed20a58': `Interactivité`,
's7136449045eff28c': `Tamoul`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Afficher les paquets instables`,
's71dec51005acc1e4': `Rangée dense`,
's72f2a02e2a5a4ee3': `Les médias`,
's730182ad28374cda': `Objet`,
's731678e227a20559': `Ce dispositif`,
's736904f276fbd441': `Sciences naturelles`,
's739544d0c858c633': str`Ou déposer 
          ${0} ici
        `,
's73cb20c838e761e1': `Sélection des coupes`,
's7417792bbe720149': `Refaire`,
's741fae02b3dd24f3': `Pixellisé`,
's743f778233e42a3f': `Insérer une parenthèse`,
's744d993d03f29851': `Écran`,
's748c0074eff45884': `Manipulation`,
's74aa0039a87141e2': `Ellipse`,
's74b9781bacfcc87c': `Pendjabi`,
's74cd20a7aece9b91': `Boîte de remplissage`,
's75109f5307578a61': `Bienvenue à WebWriter`,
's75a27f43413e02c5': `Français`,
's75d83fc3f0cfab40': `En-tête`,
's762e5704cc84089d': `Définir d'autres options de style pour les éléments sélectionnés`,
's77318393dfdb0775': `Supprimer la ligne`,
's77e594ddcc10c774': `Autoriser l'utilisation commerciale ?`,
's782eac2b3e80323d': `Marquer la sélection comme accentuée`,
's782f286a79cca35d': `Relative`,
's78673a3539cb1915': `En haut à gauche`,
's78789724e789221c': `Taille`,
's789ff24c8f03f1a4': `Espacement des lettres`,
's7995733bf97c01cc': `Serbo-croate`,
's7a99528e7b64635a': `Occitan`,
's7aaf0c06e69600f1': `Erreur avec `,
's7ae49e142487766c': `Accès communautaire`,
's7af555180b30a947': `Ouvrir les outils de développement`,
's7b4ba250601b8667': `Insérer un modèle`,
's7b560d8693ed8f42': `Debout`,
's7b9994904c4f5b54': `Tadjik`,
's7bdf0fd5b014d36c': `Forte importance`,
's7beb1e77e82363eb': `Annuler la dernière modification dans le document actif`,
's7c61118554a0ec36': `Maximum (x)`,
's7c95876637f6a9d7': `Filtre`,
's7cb4e55c59663b1c': `Entreprise`,
's7cfe12cd14df9950': `S'inscrire`,
's7d27db3c9639c6dd': `Alternatif`,
's7d8103f6f06f83d6': `Rembourrage`,
's7d864465dddbb50d': `Permettre le redimensionnement`,
's7de0e28d6c309a4e': `Autoriser les actions tactiles`,
's7dea785045c3cc74': `Appuyez sur une nouvelle combinaison de touches...`,
's7e0b179d4d1414eb': `Saisir le lien`,
's7e6570f2f1ae320f': `Synthétiser les caractères`,
's7ecb1f29332293e5': `Alignement de base`,
's7ed13ccddb1bf3c3': `Superposition`,
's7edbe0b213199995': `Baccalauréat`,
's7ede1c55e35ce9d6': `Simulation`,
's7f09197a4814079b': `Définir les options d'interactivité pour les éléments sélectionnés`,
's7f326a142e856656': `Style`,
's7fcb35d23be1e643': `Ensemble de champs`,
's80570196a9ce6d11': `Activer la télémétrie`,
's806f84eb0ace116e': `Voir ce que vous avez sélectionné et le modifier. Copier, couper, coller, épingler ou modifier la mise en page. Offre différentes options en fonction de votre sélection, par exemple la mise en forme du texte.`,
's80a42b81c52d4d8f': `Couleur de la carotte`,
's80b71fc6f43c5ce1': `Lâches`,
's812cbda653daaeba': `Cette fonctionnalité n'est pas encore mise en œuvre`,
's81c3d8809658b951': `Cachemire`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Continuer`,
's8247d32213e35f24': `Insérer un`,
's82665b2ffabc9c0a': `Site web`,
's828b1ecea8715884': `Pan (gauche)`,
's833bd0422a7ef95d': `Taille de l'onglet`,
's83420ad7b6a14db5': `Toggle Dev Tools`,
's83c15613b6f6f3c8': `En ligne uniquement`,
's83cd32b685ccc9b7': `Contrôles`,
's83f26d02dd7aa681': `Visible`,
's840fa49e8989c028': `Position/Forme`,
's844a76d1843ceb3c': `Rétablissement des valeurs par défaut`,
's84e4e8ae645b82ac': `En haut à droite (y)`,
's84e9c7f8785ca60b': `Insérer un formulaire`,
's8517ae4da104b004': `Groupe de colonnes du tableau`,
's85186a61e0d55bac': `Vidéo`,
's851a7deea5984646': `Licence Creative Commons OER ?`,
's85f9aa6d3ea0e421': `Groupe de bas de page du tableau`,
's864b0e6270e97246': `Marquer la sélection comme un commentaire latéral`,
's8670e5ad3bf0dcf8': `Enregistrer sous`,
's8688d74dd3716d6e': `Raccourcis clavier pour les commandes`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Marge de forme`,
's87cefc710b3567fb': `Contenir`,
's88676f992b2965db': `Étirer le contenu des cellules`,
's886897f2fd4edb99': `Caché`,
's886c5db2a5579873': `Concept`,
's888c71e8fcb916d3': `Sauvegarde automatique`,
's88a62d29529948fb': `Insérer un tableau`,
's89950d86c8004d4b': `Sauter aucun chevauchement`,
's89bca7498f20e041': `Clip d'arrière-plan`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Pause avant`,
's8a4ff2bd9c13498c': `Enregistrer`,
's8a6585c48ea104e9': `Masquer les cellules vides`,
's8a9eb438abac7c6a': `Étiquettes`,
's8b0432eecbd8b034': `Mise à jour`,
's8b7580c35e2aef87': `En haut à gauche (y)`,
's8bc4affa761aa8a2': `Insérer une image`,
's8c7f51cb067644c7': `Liste des données`,
's8d342ecaa9e75b9b': `Relation`,
's8d797888455f4147': `Espaces de pause`,
's8d83386457e91813': `Annuler/refaire vos modifications ou prévisualiser du point de vue de l'apprenant.`,
's8d8643013a7754d1': `Aligner le texte`,
's8df30fe2a50d3479': `Insérer une opportunité de saut de ligne`,
's8e715248c3a78446': `Couper la sélection`,
's8f29e48d6b9a1aa8': `Insérer une ligne d'en-tête de tableau`,
's8f4be9f086eb530f': `Annuler`,
's8f533296a536965e': `Enregistrer sous...`,
's8fad58c831ecf017': `Conteneur de texte Ruby`,
's8ffe7abcbed8eb43': `Vertical, de gauche à droite`,
's90105521fcc40453': `Les comptes WebWriter Cloud vous permettent de stocker des documents en ligne et de les partager avec vos étudiants. Ajoutez un compte ici et il sera disponible comme emplacement pour enregistrer, charger, partager et ouvrir des documents.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Palette de polices`,
's90f7c1cf501ea0a7': `Dédoublement de couleurs`,
's91093e0b087911ba': `Position de l'accent`,
's919e1724f589c9b1': `Fente`,
's91c5ed7769d00b65': `Insérer l'intégration`,
's9219acd5bef6269e': `Sous la gauche`,
's92548405912d46bf': `Alignement de l'encliquetage du défilement (y)`,
's9258280591309342': `Alignement de l'encliquetage du défilement (x)`,
's927d796559f49439': `Historique Origine`,
's92b177e579ef7b97': `Mise en exergue`,
's92f846b9be2e8e8d': `Marquer la sélection en italique`,
's93566b84230af4f5': `Insérer une image`,
's936aa0b239679585': `Insérer une rupture thématique (généralement affichée sous la forme d'une ligne horizontale)`,
's9370dc6afa716b57': `Frontière`,
's93f083e654a45715': `Breton`,
's94653c76b2d86a04': `Durée déterminée`,
's9485af2e7cd9418f': `École primaire`,
's94d2eee44b292567': `Basculer vers les options avancées`,
's94d61907ee22a8c1': `Coréen`,
's94eb1effbbb6498b': `Débordement`,
's951aa3a6439f1271': `Marqueur de liste`,
's9565553d163fc92a': `Le scénario`,
's957787fc6b7ea5c0': `Pan (haut)`,
's95d56e58f816d211': `Néerlandais`,
's95d8e41a64635c7c': `Espace blanc`,
's95de7e1eff6c053e': `Horizontal, de haut en bas`,
's960d3a90ac199368': `Rhéto-roumain`,
's96532132a29dd542': `Insérer un fichier audio`,
's96a045dcade75ad0': `Colonne dense`,
's9781a5bb3fcb26a3': `Sélectionnez d'abord une entreprise`,
's978522fbc9577a7e': `Somali`,
's97881699a2b21d5b': `Intervalle entre les rangs`,
's97aa76056a81bd36': `Métriques`,
's986facb3ecc9602c': `Latéralement, de droite à gauche`,
's987abd19fac8cf55': `Sous`,
's9896529e5cb20558': `Fichier externe`,
's98977a87d1b93941': `Réinitialiser les informations, les styles et les scripts`,
's990d0e0fa2ab00b5': `Galicien`,
's99229574e5692f19': `Groenlandais`,
's99a990f3841ad283': `Dossiers de `,
's99b38e000175cc84': `Barré`,
's99f110d27e30b289': `Titre`,
's9ab10fbf4c7a7322': `Position du soulignement`,
's9abadcc828884d7b': `Zone de texte`,
's9b7cd8860c8fc922': str`
          ${0} sera écrasé. Vous êtes sûr de vous ?
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Couleur de fond`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Colonne de table`,
's9cf68f87b8e6122f': `Azerbaïdjan`,
's9d167ef77aed79b6': `Couche`,
's9d2d00982edafabb': `Turc`,
's9d430adc5be110e9': `Rangée inversée`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Suppression`,
's9df571714a1efb44': `Une version sauvegardée de cet explorateur est disponible. La charger ?`,
's9e28faa598332e2b': `Insérer une vidéo`,
's9e3dbb678150edd4': `Définir la famille de polices`,
's9e40e59654c8ad67': `Colonne`,
's9e85800d3700e31c': `Poursuivre`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Variante de police`,
's9f1ecdb3061d9cbc': `Préserver les espaces`,
's9faf26107ed49fb9': `Insérer une cellule de tableau`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Transition`,
's9ff3121d30f88d52': `Normal`,
's9ffe1bbe64712bf1': `Toile`,
'sa00df4e39c72d3b4': str`
          ${0} n'est pas pris en charge
        `,
'sa013e119fec906fb': `Rangée`,
'sa01e7bf33563ef72': `Contexte Pièce jointe`,
'sa126cf8c627cec1e': `Rendu d'image`,
'sa13f72278add7513': `Sous le droit`,
'sa1647e3b36ec08d7': `Combiner le droit`,
'sa172190ea21f9b1c': `Accédez aux paramètres, ouvrez un explorateur ou créez-en un nouveau.`,
'sa1c6c459b9b5115c': `Absolu`,
'sa2cba871f6cdd99f': `Assamais`,
'sa2eff4dad1c119f1': `Modèle de grille`,
'sa30c12014e955946': `Russie`,
'sa30f1981fd1cd441': `Taille de la police`,
'sa311a24c1471a974': `Document`,
'sa352d168b262aa06': `Insérer un pied de page`,
'sa37fee6a52d18063': `Supprimer le document`,
'sa39c7ac1d37f3bce': `Marquer la sélection comme un "isolat bidirectionnel".`,
'sa3b4c01623211544': `La force`,
'sa40fd43756fa8913': `Persan`,
'sa417644bef21a9aa': `Thème sans nom`,
'sa43800e28be1bdbc': `Couleur de la décoration`,
'sa477cb1825dceb3b': `Soudanais`,
'sa492a51a707930fa': `Insérer une citation`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Légende en bas de page`,
'sa50d3c35533f1d99': `Tous les domaines`,
'sa53c5cb03a8fda50': `Épingler la sélection en tant qu'extrait dans la palette`,
'sa557ae6bee9148a6': `Progrès`,
'sa589e1df65dde0ec': `Définir la taille, l'espacement et les marges des éléments sélectionnés`,
'sa5c371b4bb75e590': `Gauche`,
'sa5c80e623459ffe4': `Insérer un en-tête`,
'sa5df1bcdba46c3fb': `Figure Légende`,
'sa602e3fd3f2d98fd': `Animation`,
'sa644d580d8a11e60': `Alignement du rubis`,
'sa645d315510dc09e': `Choisir un chemin d'accès à partir du disque`,
'sa65d4ad99f1d8c06': `Définir l'arrière-plan du texte`,
'sa6607436f60ccc1a': `Estonien`,
'sa6f8d27bca557059': `Déplacer les éléments méta/lien/style vers le haut/bas dans cet élément`,
'sa757645ad842da97': `Préserver les pauses`,
'sa75b95980cd80e78': `Éditeur`,
'sa7698b3d20a6d1ec': `Parchemin`,
'sa778acc33947c7b8': `Terminer la visite`,
'sa78a67272a4a6f95': `Formule mathématique`,
'sa79167651dce1e80': `Texte alternatif`,
'sa7af797a46c7d09a': `Pied de page du tableau`,
'sa7dbe35b758c138d': `Insérer un canevas`,
'sa7dc6b8ef3f595dc': `Insérer une source`,
'sa8279f8211b3950d': `Préserver les pauses et les espaces`,
'sa8b55cab62e439b5': `Supprimer la colonne`,
'sa8bbe0197d31b423': `Brève description`,
'sa9ff3b762365abe6': `Origine de la transformation (z)`,
'saa02e3762368ff35': `Origine de la transformation (y)`,
'saa065776236bfa28': `Transformer l'origine (x)`,
'saa33768e03c45fc8': `Taille du fichier`,
'saaad98061a20ac39': `Insérer une formule mathématique`,
'saab875d8cfcfe712': `Thème`,
'saad4380b9cc6cefd': `Alternance sur`,
'saaec15c97a9e4245': `Inversion de colonne`,
'sab0c57df694a0a09': `Début de la coupe`,
'sab4d9283896d9422': `Résolution instantanée en pixels`,
'sab55faae8e165407': `Remplissage&lt;br&gt; comme l'espace`,
'sab5e7d2a069a2951': `Certificat professionnel.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Aligner à droite`,
'sac895c732f350ac5': `Sombre`,
'saced41ddda8b2354': `Base flexible`,
'sad190f86451081c0': `Népalais`,
'sad6be321164d08c8': `Mathématiques compactes`,
'sadd352cc7f6f2307': `A l'écart`,
'sae098810f946ca7c': `Tagalog`,
'sae185e6af80ec81e': `Suédois`,
'sae1c7f13b7c0c47f': `Démarrage`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maori`,
'sae9d739068eee2c5': `Tatar`,
'saf312eaeec77a802': `Insérer une liste de description (glossaire, liste de termes)`,
'saf3da7c95cb17260': `Marquer la sélection en exposant`,
'saf440a0a592f2835': `Mise à jour de`,
'saf9e5134ba1a7d30': `Encliquetage du défilement`,
'safc6f203342d09e2': `Bascule l'aperçu du document actif`,
'sb0a7e3adf4a125ee': `En haut à droite`,
'sb0a974028c99ca6d': `Permettre des adaptations ?`,
'sb0d4f0f7993cf085': `Définir la taille de la police`,
'sb0f3327210fe18fc': `Colonnes`,
'sb0f93c1c60c0249a': `Base en rubis`,
'sb1494c08c8c720d1': `Définir la couleur du texte`,
'sb19611adbc88f711': `Avancé : Affiche les commandes d'édition de la source, par exemple pour afficher le code HTML du document ou pour ajouter des styles et des scripts personnalisés.`,
'sb206d700d26b14ff': `Souligner`,
'sb233557012dcb328': `Descendre`,
'sb26035b596566abf': `Sans nom`,
'sb2cda80610c8d6ea': `Espace tous`,
'sb2dc787b0983ebc6': `Lituanien`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Centre`,
'sb3ba3276ae93627c': `Insérer un bloc de texte préformaté`,
'sb430f5b4824de0d3': `Choisir une mise en page`,
'sb43db07b24da018a': `Amharique`,
'sb45f9fb4dba6e71a': `Non défini`,
'sb4e003a459464d85': `Kurde`,
'sb4f0310e6787d098': `Ouzbek`,
'sb4f1dffbb6be6302': `Clair`,
'sb51270e19988f9bd': `Région`,
'sb59d621e3c93cc27': `Bordures de cellules partagées`,
'sb5e9e1776242b028': `Interactions`,
'sb60bc1250aad44c1': `La portée`,
'sb60dd9d23d31ee66': `Doctorat`,
'sb6103872073d369e': `Insérer les détails`,
'sb616811735bfbafd': `Cellule de tableau`,
'sb628960829e223bb': `Sauter tous les chevauchements`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Appliquer et importer`,
'sb66e2181a7b5738a': `En activant la télémétrie, vous autorisez la collecte et la conservation des données conformément à notre politique de confidentialité.`,
'sb67e0e7c0869f982': `Différence`,
'sb68e83cda6c85af8': `En-tête de tableau`,
'sb6b268120592dc53': `Hindi`,
'sb6ca0a8bb3caae69': `Epaisseur de la décoration`,
'sb70c17f7899f9b01': `Latin`,
'sb71941f552f3504d': `Définir une valeur spéciale`,
'sb740eab4afd5a710': `Grille d'écoulement automatique`,
'sb741b6e0ca589122': `Inverser la couche`,
'sb7c77d0415de05cf': `Exécuter les tests`,
'sb7fb7568f6883ab8': `Partager le document actif`,
'sb85774dc5d18ff0f': `Confirmer`,
'sb85b1e36579852a6': `Courriel ou mot de passe invalide`,
'sb884fa76bfc55429': `L'arabe`,
'sb8a3d4df7d1c5e6b': `Équilibre`,
'sb8f610a0e8df91fc': `Luminosité`,
'sb8f855b49234b81b': `Appliquer`,
'sb905da066c10182c': `Plus sombre`,
'sb940ade1bd81be7e': `Sous la gauche`,
'sb9e9a7dd45966756': `Marquer la sélection en gras`,
'sba509fd8ed61d1d5': `Fichier non enregistré`,
'sba64d8954d027206': `Opacité`,
'sba88d90cd6c751b3': `Règle de la colonne`,
'sbaf0a7c417e388af': `Santé`,
'sbb15d427ee1aa676': `Tigrinya`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Filtre de fond`,
'sbb85a407d730e13d': `Insérer une recherche`,
'sbb86c6c96f598bb8': `Mixte`,
'sbba0156f795d8c07': `Modifier la sélection`,
'sbba865d4b437944f': `Attribut`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Désinstaller`,
'sbc5f2a81604baf9b': `Rubrique 6`,
'sbc5f2b81604bb14e': `Rubrique 5`,
'sbc5f2c81604bb301': `Rubrique 4`,
'sbc5f2d81604bb4b4': `Rubrique 3`,
'sbc5f2e81604bb667': `Rubrique 2`,
'sbc6953a36ced943f': `politique de confidentialité`,
'sbd181cd54b8402a4': `Modifier la sélection`,
'sbd35ee879d9cf770': `Texte en rubis`,
'sbd40f40cbadd38d5': `Supprimer ce paquet de widgets`,
'sbd72dc858de95ce8': `Birman`,
'sbe3c60c65f129daa': `Sciences humaines`,
'sbe4a7c8f231739b3': `ou coller/déposer/choisir un fichier`,
'sbe90de083557ef3e': `Swahili`,
'sbefb6064cba01844': `Insérer un saut de ligne`,
'sbf00e1ee999ea94e': `Insérer un script`,
'sbf519920c2017d67': `Suspension`,
'sbfa01f189a68d3e9': `Croissance flexible`,
'sbff54e740c4086eb': `Afficher les paquets inconnus`,
'sbfff51feacf30196': `Sanskrit`,
'sc0ceaa9843510f67': `Turkmène`,
'sc1611c0558728a2a': `Position`,
'sc1a155cc25899250': `Groupe de lignes du tableau`,
'sc1aa1f6051b7102a': `Roumain`,
'sc1edebeaef92b7bd': `Mise en page fixe du tableau`,
'sc1fff4f356dfb2fb': `Transformer`,
'sc24bda3c061fddf8': `Zone cliquable`,
'sc252a4e091763606': `Insérer un pied de tableau`,
'sc2536e077514accc': `Défilement`,
'sc275dd00036d16cb': `Caractère des citations`,
'sc28864200d2a3799': `Copier le code QR en tant qu'image`,
'sc2a24a9dd41a9503': `Ligne de décoration`,
'sc2b734cca2fa643b': `Pan (vers le bas)`,
'sc2e2a0dbf03723b7': `Avancé : Afficher les paquets provenant de sources inconnues dans le gestionnaire de paquets (Attention : Peut être dangereux)`,
'sc3998b77d72c2932': `Insérer un site web (sous forme de cadre en ligne)`,
'sc3ac225273c8316b': `Général`,
'sc3cfee84dbbf36ae': `Fichier local`,
'sc3f09a9b6fa4fbed': `A l'intérieur`,
'sc43767deea72e9f3': `Liste des descriptions`,
'sc462bbdd36bcba6b': `Boîte de référence`,
'sc4ee3e4ee994dafd': `Ukrainien`,
'sc50d09edf9325339': `Dialoguer`,
'sc52b67794c06a0d3': `Origine de la perspective (y)`,
'sc52e8b794c0913d6': `Origine de la perspective (x)`,
'sc53de149fcaad713': `Entre les personnages`,
'sc546f489f9c0cced': `Bascule le mode de test pour le document actif`,
'sc5bcf50d1b578d9f': `Paramètres des fonctions de police`,
'sc5cb39478b9b7625': `Marquer la sélection comme un indice`,
'sc6415b50ff928294': `Élément de la liste`,
'sc650ff15b20fe9d3': `Rotation (z)`,
'sc6578b15b2154365': `Rotation (x)`,
'sc65aff15b2183e58': `Rotation (y)`,
'sc6da0f4a7e4d710e': `Remplacement de la langue de la police`,
'sc74e3567875ce255': `La balise de votre widget et le nom de votre paquet NPM`,
'sc7eb080b96e244df': `Malais`,
'sc8ac7ef92b95df3f': `Déplacement (x)`,
'sc8af536e2084ade0': `Palette`,
'sc8b022f92b992bc2': `Déplacement (y)`,
'sc8b39af92b9c2d81': `Déplacement (z)`,
'sc8d2c7f6c33a2b32': `Définir le style de texte (alignement, indentation, espacement, etc.) des éléments sélectionnés`,
'sc8fa0e3de389ef1c': `Ajustement de la taille de la police`,
'sc9474bf7a0668d73': `Résumé`,
'sc94e314312a8900c': `Tchèque`,
'sc980855a000b76ea': `Le fond`,
'sc98b103772de63f4': `Finlandais`,
'sca7cfe2bef51b2a5': `Racine`,
'sca7fed2bef53cb99': `Rôle`,
'scabe6ecee5e01fd2': `Maltais`,
'scace301a88231cce': `Embarquer`,
'scbc55f622ec078c1': `Voir la boîte`,
'scbe537fc38ff4c13': `Colonnes automatiques de la grille`,
'scc1db59d292cbc4c': `Section`,
'scc56b218a2689c42': `Arménien`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Boîte de rembourrage`,
'scd9cedeb5ece3adb': `Trait d'union`,
'scdf536b65be39ec5': ` Créer/importer`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Idéographique`,
'sceecdd0bb404bc17': `Insérer un groupe d'options`,
'scf00d48fd5953a03': `Grecque`,
'scf932840a69dbb7c': `Portugais`,
'scf932a8577057752': `Pied de page`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `En bas à droite`,
'sd01178c54f648118': `Colonnes d'équilibre`,
'sd03bff50f87f82d4': `Caractère de césure`,
'sd05a155fe09c2866': `En ligne lors de l'utilisation de`,
'sd0864ea6cb6ef22e': `Communauté`,
'sd10fdbe6caf9a998': `Saut de ligne`,
'sd121d3b959b7888d': `Optimiser la vitesse`,
'sd1a78e667a1a139f': `Marquer la sélection comme une insertion`,
'sd1cffad290ea5b3b': `Conserver tous les`,
'sd1f10284eeb17b25': `Fidji`,
'sd1f44f1a8bc20e67': `Courriel`,
'sd1f81984eeb7c0e8': `Remplir`,
'sd29dc07235eea0f5': `Devis`,
'sd2addf69477cd4b4': `Paquet d'importation`,
'sd2ed26defc646d47': `Filtre de fond`,
'sd2ef82b8ea877c6d': `Afrikaans`,
'sd319aae1401f1e19': `Fixe`,
'sd3a288c1094b8a63': `Largeur de la règle de la colonne`,
'sd3c65ef5c380c046': `Encart`,
'sd3dcb76f7b28adb8': `Letton`,
'sd3eca1e0f4209f6e': `Découper tout`,
'sd3f402df8619ddcd': `Ces informations vous concernant sont automatiquement ajoutées aux nouveaux documents. Vous pouvez les modifier pour chaque document dans l'éditeur de métadonnées.`,
'sd4368b12645d3c0f': `Insérer un portail`,
'sd452cebf4a0313d1': `Afficher les commandes d'édition de la source`,
'sd48cc52117f4d68b': `Italien`,
'sd52660ee947ca58b': `Insérer une colonne de tableau`,
'sd588d17a1b25c220': `Débordement du texte`,
'sd5be6f6d85fc0c9b': `Zoulou`,
'sd5bf67958b08b4cf': `Enseignement supérieur.`,
'sd5cf95145e4d89ca': `Épingler cet extrait`,
'sd5fd9d11a92f5b1d': `En bas à gauche (y)`,
'sd60c9bbc51375635': `Insérer un bouton`,
'sd66c4767fa3dde28': `Couleur d'accent`,
'sd679c8b1bf8cc8a5': `Petites capitalisations`,
'sd7086c4425c53c80': `Famille de polices`,
'sd837f42ac7cbfb58': `Forme (extérieur)`,
'sd88076d2994ee0fb': `Exclusion`,
'sd89a2e529b31ef43': `Revenir en arrière`,
'sd8a345e95668b73b': `Vertical, de droite à gauche`,
'sd8ce9e57270b030d': `Étirement de la police`,
'sd8ecf227c7c49331': `Mathématiques`,
'sd8f923198e0c5c6a': `Fin`,
'sd9c21e5f60d6bdd8': `Danois`,
'sd9ff8e2612e63d50': `Dimensionnement de la boîte de bordure`,
'sda2d76b976502a8d': `Ouvrir...`,
'sda344aacb837387e': `Position dans le conteneur`,
'sda5b6fa8b771f996': `Flotteur à gauche`,
'sda9254d1f1228e1a': `Hongrois`,
'sdb1595f5c742dfbb': `Entrée`,
'sdb711380a28fec75': `Insérer une liste (ordonnée)`,
'sdb73788b3c975f16': `Auto`,
'sdbee7e0523a23a42': `En bas à droite (y)`,
'sdc48456f9a27ae02': `Générateur`,
'sdc70d81cf6c28533': `Géorgien`,
'sdd1ff479d04ac140': `Public`,
'sdd2fc8919a9c3111': `Mode de fusion de l'arrière-plan`,
'sdd35b688281b6dea': `Japonais`,
'sddc49047f66a64ab': `Aucune description n'est fournie`,
'sdef34fe08bb28b09': `Chinois (simplifié)`,
'sdf62e305e1594805': `Marquer la sélection avec une annotation ruby`,
'sdf946172dfa0328f': `Exposé des motifs`,
'sdf9bc5d9b7f3e3de': `Alignement`,
'se036b53f145441cd': `Contenu mixte`,
'se06f459fccdc3ce9': `Aligner la dernière ligne de texte`,
'se0a782a8be8e018b': `Norvégien`,
'se0cda6b80a1bb50f': `Slovaque`,
'se0f67eae944f8f94': `Muet`,
'se1312d6528f9a259': `Yoruba`,
'se16c5e66886fbc59': `Article`,
'se1f5bb0386c88f96': `Définit la couleur du texte sélectionné`,
'se219da7b1e955c65': `Un formatage clair`,
'se25e4f2cb77b8be8': `Langage pour l'interface WebWriter et nouveaux documents`,
'se2796c5824ec8916': `Visibilité du contenu`,
'se308836a594808b6': `Cingalais`,
'se36c5b1baf5e0660': `N'importe où`,
'se39c065efa467782': `Basque`,
'se3b4c857f91f80d7': `Raccourcis clavier`,
'se47baf2fd16b9d2b': `Modèle`,
'se48bd9e6c2a3109d': `Comptes`,
'se58467472725ad0c': `Résolution de l'image`,
'se58f06c2b0583ff7': `Choisir les coordonnées`,
'se5dc1e97fb743ade': `Espacement`,
'se619a501d1bfe6a5': `Enveloppe`,
'se62385ac082368d2': `Marquer la sélection comme source de citation`,
'se6297163cac9d276': `Editer la source`,
'se633223a0b88625e': `Placement des cellules`,
'se638417c560cfe5c': `Interruption à l'intérieur`,
'se64f418b4e733b6c': `Insérer une sortie`,
'se79c0a3ac70d8fb3': `Taux d'Asp. (x)`,
'se79fae3ac710dc36': `Ratio Asp. (y)`,
'se7fad370d8fb4cec': `Optimiser la lisibilité`,
'se8a94b4effa2033e': `Alphabétique`,
'se95d4e55ea186d9a': `Couleur de la barre de défilement`,
'se96d43a515b8451c': `Slovène`,
'se96fd76ba1b2975a': `Centrale`,
'se9ac05f36b004eb0': `Masquer la visite d'introduction. Désactiver pour que la visite s'affiche à nouveau.`,
'se9b1fec72ffd8f48': `Locale`,
'sea24bdcaa2bd2dec': `Instantané obligatoire`,
'sea52df2b70a5c10d': `Rubis`,
'sea6e7291e27ec53f': `Bascule l'éditeur de métadonnées`,
'sea896ed51ad33287': `Aucun style spécifique n'est disponible`,
'seaaaeb09e3b4e78b': `Commandes d'édition`,
'seabae79729c4b2ad': `Toggle email`,
'seaecc8267bad6234': `Collège`,
'seaf97719986faf4f': `Écart`,
'seb19675a580f0628': `Éviter la colonne`,
'seb4e52ef5ec7a7dc': `Couleurs/Effets`,
'seb8982ae8c3cdcc5': `Indonésien`,
'sebbced89e0db2894': `Première ligne de base`,
'sec02109a0dd2a6c8': `Couleur de l'accent`,
'sec2557a35b702525': `Variable`,
'sec2da4aa7a02b925': `islandais`,
'sec30fbb20f102670': `Insérer un résumé`,
'sec8b0b6c729816b6': `Groupe de tête`,
'seccd05955adb76bc': `Affiche`,
'sed17285cd25d6389': `Répertoire où se trouve le fichier package.json`,
'sed318ec045c5144f': `Plus de`,
'sed713f1b916fb469': `Espacement des bordures (x)`,
'sed74a31b9172942c': `Espacement des bordures (y)`,
'sed86bd0deb2e5372': `Transformer le texte`,
'see2fcaedf9743ec6': `Localisation`,
'seec6798afe90ffc8': `Imprimer`,
'sef00c258bc1ecf1e': `Cet explorable a subi des modifications non approuvées.`,
'sef23dd271edd4a8b': `En bas à gauche`,
'sef24caccbd4645ef': `Rétrécissement de la flexion`,
'sef49aec68fd1dc66': `Nom`,
'sef73fe18e351eb35': `Mots clés`,
'sef75f458d77491af': `Groupe d'options`,
'sefcf950b3cc4fc3b': `Langue`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Contenu`,
'sf0cab2483f66aa2e': `Sur mesure`,
'sf0e261e04eda82ff': `Apparence`,
'sf1045382c1fd9a85': `Couleurs d'impression exactes`,
'sf14c35392ec7bf10': `Cette fonctionnalité n'est pas disponible dans Firefox. Elle est disponible dans Chrome ou Edge.`,
'sf14f9d5f9f6ca342': `Plus léger`,
'sf1868dc19e3917bb': `Espagnol`,
'sf190149f9d8bbb2a': `Mode d'écriture`,
'sf1e79171c4856543': `Vous êtes sûr de vous ? Cette action ne peut pas être annulée, tous vos paramètres seront supprimés et réinitialisés.`,
'sf21c1f60c7515f44': `Marquer la sélection comme échantillon de sortie`,
'sf21fb4f4b9e8911f': `Largeur`,
'sf22a3737146ec910': `WebWriter peut intégrer des SVG directement dans le document.`,
'sf2514d5dc78b1654': `Insérer un widget`,
'sf28903d4ca0ddcfc': `Supprimer ce compte`,
'sf2ab37af0abc55ef': `Cacher la visite d'introduction`,
'sf2bdb0b4d7b9c039': `Bengali`,
'sf2cbb5e519264e67': `Redimensionner horizontalement et verticalement`,
'sf2d5cbc2fe0ad65a': `Collant`,
'sf2d96d0eb32cb81f': `Composition de l'animation`,
'sf2de3dbe2108637a': `Rendu des formes`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `En ligne`,
'sf39736a666dbb038': `Insérer une piste`,
'sf3c4da68b08a2590': `Malgache`,
'sf471ec2496f904cc': `Rejeter les modifications`,
'sf4849bc200e279ed': `Légende du tableau`,
'sf486ca1fdbe08645': `Insérer une figure`,
'sf4b537d4cbd8f5fd': `Haut de page`,
'sf4e0e02a5277ef23': `Insérer une zone de texte`,
'sf4f067d41efd4b83': `Échelle (y)`,
'sf4f3cbd41f002b46': `Échelle (x)`,
'sf4fa67d41f05a008': `Échelle (z)`,
'sf5197db2d5f2926a': `Rotation`,
'sf52d840949a980d1': str`
          ${0} sera définitivement supprimée. Vous êtes sûr de vous ?
        `,
'sf55d634dcc743595': `Services`,
'sf59c9081d106dd9c': `Marquer la sélection comme variable`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Supprimer un document`,
'sf65df67a03bebe4b': `Requis pour ce widget`,
'sf6673729c03ae999': `Réinitialiser WebWriter`,
'sf67571992e7dc88e': `Durée complète`,
'sf6b4934598f7ed10': `Autoriser la sélection`,
'sf6e1665c7022a1f8': `Mot de passe`,
'sf79e0d78b56444f1': `Extrémité en ligne`,
'sf7a5f7a7c80c3082': `Les deux`,
'sf7c0eba7c822e3d6': `Gras`,
'sf86bd4d2982f3b74': `Marquer la sélection comme un code`,
'sf8e82313fa411494': `Marquer la sélection comme un lien`,
'sf955eff73fb6b573': `Serbe`,
'sf9929e2d356260c5': `Multiplier`,
'sf993bb199fefbe04': `Tous`,
'sf9ecf969dd4b8164': `Les deux bords`,
'sf9f2c719a04066ec': `Application`,
'sfa49a5bb1a5d353e': `Accès privé`,
'sfa59c7777e2a0eeb': `Insérer une liste de données`,
'sfaa0a67db5c11f72': `Indentation de la première ligne de texte`,
'sfb231a52211b133f': `Pas d'habillage du texte`,
'sfb68cae41d749423': `Initiale`,
'sfb9b6edb0ed378c9': `Source des citations`,
'sfbbab09dbe553571': `Insérer un dessin vectoriel (SVG)`,
'sfc00292e778b67e2': `Compteur`,
'sfc63e31ac7c956ed': `Sélectionner`,
'sfc815c9078bba30a': `Télécharger le code QR sous forme d'image`,
'sfcdd8e672c75b713': `Adresse`,
'sfcebd18506f1e535': `Débit`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Sortie`,
'sfdb1e4d90981a535': `Partager ce document`,
'sfdeef3dccf409f81': `Ce mot-clé est nécessaire pour les widgets`,
'sfe6e758ad2603c1d': `Maîtrise`,
'sfee1c12daf838935': `Brûlure de couleur`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Insérer un dialogue`,
'sffa395f64ec6ac36': `Bulgare`,
'sffdadf0a576fd802': `Hauteur`,
'spaceKey': `L'espace`,
'tabKey': `⭾ Tab`,
'upKey': `↑ Vers le haut`,
's0dc07f97c821463c': `Comment selection`,
's780099588362f80f': `Definition item`,
's105540b7756c0232': `Definition term`,
's98b1cb8fb62909ec': `Group`,
's151349210ac1d2d8': `Insert a group`,
's2739460e44320108': `Chinese (Traditional)`,
'sdc12d4d35420eeb7': `Comments`,
's74540c1b595a229c': `TeX Formula`,
'sc221faca1ecb4aee': `Anonymous`,
's0b7ae9543c001867': `Reply`,
's52fb1524cb25d7ab': `New thread`,
'scbf29ce484222325': ``,
    };
  